import {createContext, useContext} from 'react';

export const defaultContext = {
  onSubmit: () => {},
  onSubmitSuccess: () => {},
  onCustomerCreated: () => {},
  onCustomerEdited: () => {},
  clearInspectionData: () => {},
  submitButtonLabel: 'submit',
  disabledFirstShumaReasonID: false,
  initialValuesStep13: {},
  decisionTreeOptions: {},
  options: {
    shumaId: '',
    disabled: [],
  }
};

export const CreateShumaContext = createContext(defaultContext);
CreateShumaContext.displayName = 'CreateShuma';

export const useCreateShumaContext = () => useContext(CreateShumaContext);
